/**
 * This feature's routes, as constants.
 *
 * Separate from `routes.tsx` so a screen can link to another screen without
 * importing the module that builds the route table — which would be a cycle,
 * since the table imports the screens.
 */

export const CATALOG_PATHS = {
  consultation: "/catalogue/articles",
  consultationArticle: "/catalogue/articles/$id",
  categories: "/catalogue/arborescence",
  attributes: "/catalogue/attributs",
  articleSetup: "/catalogue/parametrage-article",
  brands: "/catalogue/marques",
  availability: "/catalogue/disponibilite",
  fiches: "/catalogue/fiches",
  fiche: "/catalogue/fiches/$id",
  reliability: "/catalogue/diagnostic-fiabilite",
} as const;
